import { ElementType } from "react";
import SchoolIcon from "@mui/icons-material/School";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import TrainIcon from "@mui/icons-material/Train";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import FlightIcon from "@mui/icons-material/Flight";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import BusinessIcon from "@mui/icons-material/Business";
import ParkIcon from "@mui/icons-material/Park";
import MovieIcon from "@mui/icons-material/Movie";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import HotelIcon from "@mui/icons-material/Hotel";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import ChurchIcon from "@mui/icons-material/Church";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import BuildIcon from "@mui/icons-material/Build";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import GavelIcon from "@mui/icons-material/Gavel";
import AttractionsIcon from "@mui/icons-material/Attractions";
import MuseumIcon from "@mui/icons-material/Museum";

export interface Category {
  category_id: string;
  name: string;
  subcategories: {
    subcategory_id: string;
    name: string;
  }[];
}

export const getCategoryFromTypes = (
  googleTypes: string[],
  categories: Category[]
) => {
  if (!googleTypes || !categories) {
    return { category: "Other", subcategory: "Other" };
  }

  const normalize = (str: string) => str.toLowerCase().replace(/_/g, ' ');

  for (const googleType of googleTypes) {
    const normalizedGoogleType = normalize(googleType);
    
    for (const cat of categories) {
      if (cat.subcategories) {
        for (const sub of cat.subcategories) {
          if (normalize(sub.name) === normalizedGoogleType) {
            return {
              category_id: cat.category_id,
              category: cat.name,
              subcategory_id: sub.subcategory_id,
              subcategory: sub.name,
            };
          }
        }
      }
    }
  }

  return { category: "Other", subcategory: "Other" };
};

export const getAllowedSubcategories = (categories: Category[]) => {
  const allowed = new Set<string>();
  categories.forEach((cat) => {
    cat.subcategories.forEach((sub) => allowed.add(sub.name));
  });

  return allowed;
};

export const getPlaceCategoryIcon = (
  category: string,
  subCategory?: string
) => {
  const categoryLower = category.toLowerCase();
  const subCategoryLower = subCategory?.toLowerCase() || "";

  const subCategoryMap: Record<string, ElementType> = {
    school: SchoolIcon,
    university: SchoolIcon,
    hospital: LocalHospitalIcon,
    doctor: LocalHospitalIcon,
    pharmacy: LocalPharmacyIcon,
    drugstore: LocalPharmacyIcon,
    airport: FlightIcon,
    bus: DirectionsBusIcon,
    train: TrainIcon,
    rail: TrainIcon,
    subway: TrainIcon,
    parking: LocalParkingIcon,
    gas_station: LocalGasStationIcon,
    cafe: LocalCafeIcon,
    coffee: LocalCafeIcon,
    grocery: LocalGroceryStoreIcon,
    supermarket: LocalGroceryStoreIcon,
    movie: MovieIcon,
    cinema: MovieIcon,
    attraction: AttractionsIcon,
    tourist: AttractionsIcon,
    museum: MuseumIcon,
    park: ParkIcon,
    bank: AccountBalanceIcon,
    hotel: HotelIcon,
    lodging: HotelIcon,
    church: ChurchIcon,
    temple: ChurchIcon,
    gym: FitnessCenterIcon,
    fitness: FitnessCenterIcon,
    zoo: AttractionsIcon,
  };

  const categoryMap: Record<string, ElementType> = {
    education: SchoolIcon,
    health: LocalHospitalIcon,
    automotive: DirectionsCarIcon,
    transportation: DirectionsBusIcon,
    food: RestaurantIcon,
    restaurant: RestaurantIcon,
    shopping: ShoppingCartIcon,
    business: BusinessIcon,
    office: BusinessIcon,
    corporate: BusinessIcon,
    entertainment: AttractionsIcon,
    culture: MuseumIcon,
    finance: AccountBalanceIcon,
    government: GavelIcon,
    lodging: HotelIcon,
    housing: HotelIcon,
    nature: ParkIcon,
    outdoors: ParkIcon,
    worship: ChurchIcon,
    sport: FitnessCenterIcon,
    services: BuildIcon,
  };

  for (const [key, icon] of Object.entries(subCategoryMap)) {
    if (subCategoryLower.includes(key)) return icon;
  }

  for (const [key, icon] of Object.entries(categoryMap)) {
    if (categoryLower.includes(key)) return icon;
  }

  return LocationOnIcon;
};
